export default "/assets/images/mila-insights.webp?78285be1379cf90291a9eb2e2f0d7712";